import React from 'react';
import {Modal, Col}  from 'react-bootstrap'

export function Header(props) {
  return (
    <Modal.Header closeButton>
      <Modal.Title>{props.title}</Modal.Title>
    </Modal.Header>
  )    
}

export function SpacerCol() {
  return(
    <Col md="1"></Col>
  )
}

export function InputCommon (props) {
  return (
    <Col md="5" className="label-item">
      <label htmlFor={props.id}>{props.prompt}</label>
      {props.element}
    </Col>
  )
}

export function inputBorder(valid) {
  return valid ? "input-ok" : "input-issue";
}
